module.exports = __webpack_public_path__ + "img/14.ed06a9b0.webp";